// Company constants and configuration
export const COMPANY_INFO = {
  name: "ReactiveStack",
  tagline: "Reactive Solutions, Scalable Future",

  description: {
    short:
      "A specialized React development firm crafting exceptional web and mobile experiences with TypeScript precision.",

    long: `ReactiveStack is a forward-thinking software development firm specializing in modern React ecosystem solutions. 
We craft exceptional web applications using React and Tailwind CSS, and build powerful cross-platform mobile apps with React Native. 
Every line of code we write leverages TypeScript's type safety to ensure robust, maintainable, and scalable applications.

Our expertise spans the complete React stack - from responsive web interfaces that captivate users to native mobile experiences that perform flawlessly across platforms. We believe in reactive programming principles, clean architecture, and delivering solutions that adapt and scale with your business needs.

At ReactiveStack, we don't just write code - we engineer digital experiences that drive results.`,
  },

  expertise: [
    "React Web Development",
    "React Native Mobile Apps",
    "TypeScript Development",
    "Tailwind CSS Styling",
    "Frontend Architecture",
    "Cross-Platform Solutions",
    "Performance Optimization",
    "Modern UI/UX Design",
  ],

  technologies: {
    frontend: ["React", "React Native", "Expo", "TypeScript", "Tailwind CSS"],
    tools: ["ESLint", "Prettier", "Jest", "React Testing Library", "Git"],
    deployment: ["Vercel", "Netlify", "AWS", "Docker"],
  },

  values: [
    "Type Safety First",
    "Performance Driven",
    "User-Centric Design",
    "Code Quality Excellence",
    "Continuous Innovation",
  ],
} as const;

export const CONTACT_INFO = {
  email: "mudassir@reactivestack.net",
  phone: "+1 (555) 123-REACT",
  location: "Global Remote Team",

  social: {
    github: "https://github.com/reactivestack",
    twitter: "https://twitter.com/reactivestack",
    linkedin: "https://linkedin.com/company/reactivestack",
    upwork: "https://www.upwork.com/freelancers/~010b782d6523395b1e", // Replace with actual Upwork profile URL
  },
} as const;

// Branding and logo usage examples
export const BRANDING = {
  signature: {
    description:
      "White 'Reactive' + neon green 'Stack' with synchronized glow effects",
    colors: { reactive: "white", stack: "#00ff88" },
  },
  logo: {
    animated: {
      description:
        "Use for hero sections, loading states, and interactive areas",
      props: { size: 120, animated: true },
    },
    static: {
      description: "Use for headers, footers, and performance-critical areas",
      props: { size: 32, color: "default" as const },
    },
    favicon: {
      description: "Simplified version for browser tabs and bookmarks",
      sizes: [16, 32, 192],
    },
  },
} as const;
